import React, { Component } from 'react';
import { Link,Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Part4 extends Component {

    render() {

        var userToken = localStorage.getItem('token');
        if (!userToken) {
            return <Navigate to='/login' replace="true" />
        }

        return (
            <div className="docs-content">
                <div className="container">

                    {/* ========================= */}
                    {/* 1. AUTHENTICATION MODEL */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            7. Authentication Model
                        </h1>

                        <div className="alert alert-info">
                            Defines how a PSP verifies the caller.
                        </div>

                        <h5 className="mt-4">Common Authentication Types</h5>

                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">

                                <li>
                                    <strong>API Key</strong><br />
                                    Static shared secret. Simple, low assurance.
                                </li>

                                <li className="mt-3">
                                    <strong>Basic Auth</strong><br />
                                    Username/password over TLS.
                                </li>

                                <li className="mt-3">
                                    <strong>HMAC / Signature</strong><br />
                                    Cryptographic proof of request integrity.
                                </li>

                                <li className="mt-3">
                                    <strong>OAuth / JWT</strong><br />
                                    Token-based delegated access.
                                </li>

                            </ul>
                        </div>

                        <div className="alert alert-warning mt-4">
                            Signature-based authentication must clearly specify:
                            <ul className="mb-0 mt-2">
                                <li><strong>Fields included</strong></li>
                                <li><strong>Field order</strong></li>
                                <li><strong>Hashing algorithm</strong></li>
                                <li><strong>Encoding format</strong></li>
                            </ul>
                        </div>

                    </article>


                    {/* ========================= */}
                    {/* 2. TRANSPORT PROTOCOL */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            8. Transport Protocol
                        </h1>

                        <div className="row mt-4">

                            <div className="col-md-6">
                                <div className="card p-3 border-success h-100">
                                    <h5 className="text-success">REST</h5>
                                    <ul className="mb-0 doc-page">
                                        <li>Request/response model</li>
                                        <li>Stateless</li>
                                        <li>JSON or XML payloads</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="card p-3 border-primary h-100">
                                    <h5 className="text-primary">GraphQL</h5>
                                    <ul className="mb-0 doc-page">
                                        <li>Query-based interaction</li>
                                        <li>Strongly typed schema</li>
                                        <li>Often stateful via tokens</li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                        <div className="alert alert-dark mt-4">
                            Transport choice affects:
                            <ul className="mb-0 mt-2">
                                <li><strong>Retry behavior</strong></li>
                                <li><strong>Observability</strong></li>
                                <li><strong>Tooling complexity</strong></li>
                            </ul>
                        </div>

                    </article>

                    <article class="docs-article" id="section-3">
                        <section class="docs-section row" id="item-3-1">
                            <div class="col-12">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-three-doc" tabIndex="-1"
                                                aria-disabled="true"><i class="bi bi-arrow-left"></i> &nbsp;
                                                Part III
                                            </Link>
                                        </li>
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-five-doc">
                                                Part V &nbsp; <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </section>
                    </article>

                </div>

                <ToastContainer closeOnClick autoClose={2000} />
            </div>
        )
    }
}